import { useId } from 'react';

/** A numeric cell in a dense table that's editable inline. */
export function NumCell({
	value,
	step = 0.01,
	onChange,
}: {
	value: number;
	step?: number;
	onChange: (v: number) => void;
}) {
	const inputId = useId();
	return (
		<input
			id={inputId}
			type="number"
			step={step}
			value={value}
			onChange={(e) => onChange(Number(e.target.value))}
			aria-label="Price value"
			style={{
				width: '100%',
				fontSize: 12,
				padding: '3px 4px',
				border: '.5px solid #ddd',
				borderRadius: 4,
				textAlign: 'right',
			}}
		/>
	);
}
